export class ContactMessage {
  constructor(data = {}) {
    this.id = data.id || "";
    this.fullName = data.fullName || "";
    this.email = data.email || "";
    this.phoneNumber = data.phoneNumber || "";
    this.message = data.message || "";
    this.companyName = data.companyName || "";
    this.createdAt = data.createdAt ? new Date(data.createdAt) : new Date();
    this.status = data.status || "unread"; // unread, read, replied
  }

  static fromJson(json) {
    return new ContactMessage(json);
  }

  toJson() {
    return {
      id: this.id,
      fullName: this.fullName,
      email: this.email,
      phoneNumber: this.phoneNumber,
      message: this.message,
      companyName: this.companyName,
      createdAt: this.createdAt.toISOString(),
      status: this.status,
    };
  }

  // Helper methods
  isValid() {
    return this.fullName && this.email && this.phoneNumber && this.message;
  }

  getDisplayDate() {
    return this.createdAt.toLocaleDateString();
  }

  isUnread() {
    return this.status === "unread";
  }

  markAsRead() {
    this.status = "read";
  }

  markAsReplied() {
    this.status = "replied";
  }
}
